
        import * as module0 from './controllers/accordion_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/highlight_controller.js';import * as module3 from './controllers/mega_menu_controller.js'
        const modules = {
            "./controllers/accordion_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/highlight_controller.js": module2,
            "./controllers/mega_menu_controller.js": module3,
        };
        export default modules;
      